import React from "react";
import { txtA, txtE } from "../../../../Label/Lbl";
import Grid from "@material-ui/core/Grid";
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { getTotalAmount } from "../../../../utils/utils";

const InvTotal = (props) => {
  const { sta, inv, premiApp, locInv } = props;
  const clas = useInvAF();
  const styfC = { fontWeight: "1300" };
  const styfCA = { fontWeight: "1300", textAlign: "right" };

  const tot_all = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(getTotalAmount(sta.tot));

  const tot_discount = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.discount);

  const tot_vat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.amountOfVat);

  const tot_before = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(getTotalAmount(sta.tot) - sta.tot?.discount);

  
  const tot_before_Re = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(getTotalAmount(sta.tot));


  const tot_net = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.tot_net);

  const tot_net_Re = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sta.tot.tot_net+sta.tot?.discount);


  const totalsRe_desc = () => {
    return (
      <Grid
        item
        container
        style={{ fontFamily: "Amiri-Regular" }}
      >
        <>
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal}>
            <div style={styfCA}>  {"الإجمالي قبل الضريبة"}</div>{" "}
          </Grid>
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal}>
            {"Total Before Tax"}
          </Grid>
          <Grid container item xs={2} className={clas.BdyborBtRTOPTotal} style={{ textAlign: "center" }}>
            {tot_before_Re}
          </Grid>
          {/* ------------------------ */}
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
            <div style={styfCA}> {"اجمالي الضريبة"}
              {"("}{inv.tax}{"%"}{")"}</div>{" "}
          </Grid>
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
            {"Total VAT"}
            {"("}{inv.tax}{"%"}{")"}
          </Grid>
          <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
            {tot_vat}
          </Grid>
          {/* ------------------------ */}
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
            <div style={styfC}>{"الإجمالي شامل الضريبة"}</div>{" "}
          </Grid>
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
            {txtE.tot_net}
          </Grid>
          <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
            {tot_net_Re}
          </Grid>
          {/* ------------------------ */}
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2} >
            <div style={styfCA}>{"نسبة خصم ضمان الأعمال"} </div>{" "}
          </Grid>
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
            {"Retention %"}
          </Grid>
          <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
            {locInv?.desc_perc ?? 0}
          </Grid>
          {/* ------------------------ */}
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2} >
            <div style={styfCA}>{"مبلغ خصم ضمان الأعمال"} </div>{" "}
          </Grid>
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
            {"Retention Amount"}
          </Grid>
          <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
            {tot_discount}
          </Grid>
          {/* ------------------------ */}
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2} >
            <div style={styfCA}>{"الصافي المطلوب دفعه"} </div>{" "}
          </Grid>
          <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
            {"Net Amount Payable"}
          </Grid>
          <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
            {tot_net}
          </Grid>
          {/* ------------------------ */}

        </>
        {premiApp.billTemplate === 19 &&
          (
            <Grid
              item
              container
              xs={12}
              style={{
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                fontWeight: "bold",
                direction: "rtl",
                fontFamily: "Amiri-Regular",
                textAlign: "right"
              }}
            >
              {inv.notes}
            </Grid>
          )}

      </Grid>
    );
  }

  const mainTotals = () => {
    return (
      <Grid
        item
        container
        style={{ fontFamily: "Amiri-Regular" }}
      >
        <Grid container item xs={5} className={clas.BdyborBtRTOPTotal}>
          <div style={styfCA}>  {"الإجمالي"} {"(غير شامل الضريبة القيمة المضافة)"}</div>{" "}
        </Grid>
        <Grid container item xs={5} className={clas.BdyborBtRTOPTotal}>
          {txtE.amountWithVat}
        </Grid>
        <Grid container item xs={2} className={clas.BdyborBtRTOPTotal} style={{ textAlign: "center" }}>
          {tot_all}
        </Grid>
        {premiApp.billTemplate === 15 ? null :
          (
            <>
              <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2} >
                <div style={styfCA}>   {txtA.discount}</div>{" "}
              </Grid>
              <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
                {txtE.discount}
              </Grid>
              <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
                {tot_discount}
              </Grid>
              <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
                <div style={styfCA}>  {"الاجمالي بعد الخصم"}</div>{" "}
              </Grid>
              <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
                {"Amount After Discount"}
              </Grid>
              <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
                {tot_before}
              </Grid>

            </>
          )
        }
        <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
          <div style={styfCA}> {" مجموع ضريبة القيمة المضافة"}
            {"("}{inv.tax}{"%"}{")"}</div>{" "}
        </Grid>
        <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
          {"Total VAT"}
          {"("}{inv.tax}{"%"}{")"}
        </Grid>
        <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
          {tot_vat}
        </Grid>

        <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
          <div style={styfC}>{txtA.tot_net}</div>{" "}
        </Grid>
        <Grid container item xs={5} className={clas.BdyborBtRTOPTotal2}>
          {txtE.tot_net}
        </Grid>
        <Grid container item xs={2} className={clas.BdyborBtRTOPTotal2} style={{ textAlign: "center" }}>
          {tot_net}
        </Grid>
        {(premiApp.billTemplate !== 13) &&
          // {(premiApp.billTemplate === 17 || premiApp.billTemplate === 5) &&
          (<>
            <Grid container item xs={6} className={clas.BdyborBtRTOPTotal2}>
              {"اجمالي المدفوع"}    {"     :"}  {sta?.tot?.inv_type_name == "نقدية"
                ? sta?.tot?.tot_net?.toFixed(2)
                : sta?.tot?.paid}
            </Grid>
            <Grid container item xs={6} className={clas.BdyborBtRTOPTotal2}>
              {"اجمالي المتبقي"}     {"     :"}            {sta.tot?.inv_type_name == "نقدية"
                ? 0
                : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
            </Grid>
          </>
          )}


        {premiApp.billTemplate === 19 &&
          (
            <Grid
              item
              container
              xs={12}
              style={{
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                fontWeight: "bold",
                direction: "rtl",
                fontFamily: "Amiri-Regular",
                textAlign: "right"
              }}
            >
              {inv.notes}
            </Grid>
          )}
        {premiApp.billTemplate === 13 && (
          <>
            <Grid container item xs={3} className={clas.BdyborBtRTOPTotal2}>
              {"اجمالي المدفوع"}    {"     :"}  {sta?.tot?.inv_type_name == "نقدية"
                ? sta?.tot?.tot_net?.toFixed(2)
                : sta?.tot?.paid}
            </Grid>
            <Grid container item xs={3} className={clas.BdyborBtRTOPTotal2}>
              {"اجمالي المثبفي"}     {"     :"}            {sta.tot?.inv_type_name == "نقدية"
                ? 0
                : sta?.tot?.tot_net?.toFixed(2) - sta?.tot?.paid}
            </Grid>

            <Grid container item xs={3} className={clas.BdyborBtRTOPTotal2}>
              {"الرصيد قبل"}     {"     :"}

              {inv.ProcType_InvProc === "11" || inv.ProcType_InvProc === "12" ? (parseFloat(sta.tot?.cust_balance_new) + parseFloat(inv.agel_part))?.toFixed(2)
                : (parseFloat(sta.tot?.cust_balance_new) - parseFloat(inv.agel_part))?.toFixed(2)}
              {/* {sta.tot?.cust_balance_old?.toFixed(2)} */}
            </Grid>

            <Grid container item xs={3} className={clas.BdyborBtRTOPTotal2}>
              {"الرصيد بعد"}     {"     :"}
              {sta.tot?.cust_balance_new?.toFixed(2)}
            </Grid>
          </>
        )}
      </Grid>
    );
  }

  return (
    <>
      {sta?.tot?.re_disc ?
        totalsRe_desc() : mainTotals()}
    </>
  );

};

export default InvTotal;
